module.exports = __webpack_public_path__ + "src/assets/games/9/234.jpg";